import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

interface iConvocatoria {
	ID?: number, // Identificador
	Est_Programa_ID?:number,
	Tipo_Sector_ID?:number,
	Nombre?: string,
	Descripcion?: string,
	Imagen?:string,
	Proceso?:string,
	Pub_Resultados?:string,
	Periodo_Inicio?:string,
	Periodo_Fin?:string,
	Formulario_ID?:number,
	Periodo_Ini_Renov?:string,
	Periodo_Fin_Renov?:string,
	Tipo_Verifica_ID?:number
}
interface iPaginado{
	NumeroPagina?:number,
	NumeroRegistros?:number
}
@Injectable({
	providedIn: 'root'
})
export class ConvocatoriasService {

	constructor(private http:HttpClient) { }

	listarConvocatorias(pagina, registros){
	const paginador = {
		NumeroPagina: pagina,
		NumeroRegistros: registros,
	};
	return this.http.post<any>(`${environment.ip}/Convocatoria/Listar/`, paginador)
	}
	mostrarConvocatoria(ID?){
			let cadena = environment.ip + '/Convocatoria'
			if (ID === undefined){
				return this.http.get<any>(cadena)
			} else {
				return this.http.get<any>( `${cadena}/${ID}`)
			}
		}
	crearConvocatoria(Data){
		return this.http.post<any>(environment.ip + '/Convocatoria/Crear/',Data)
	}
	actualizarConvocatoria(Data){
		return this.http.put<any>(environment.ip + '/Convocatoria/Actualizar/',Data)
	}
	actualizarEstatusConvocatoria(ID) {
		return this.http.delete<any>(`${environment.ip}/Convocatoria/${ID}`)
	}
	listaTipoSector() {
		return this.http.get<any>(`${environment.ip}/Convocatoria/ListaTipoSector`)
	}
	listaTipoVerificacion(){
	return this.http.get<any>(`${environment.ip}/Convocatoria/ListaTipoVerificacion`)
	}
	listaFormularios(){
	return this.http.get<any>(`${environment.ip}/Convocatoria/ListaFormularios`)
	}
	obtenerDocumentosRequeridos(ID){
		return this.http.get<any>(`${environment.ip}/Convocatoria/ObtenerDocumentosRequeridos/${ID}`)
	}
}
